export default __webpack_public_path__ + "static/media/Slip.87c65ec1.svg";